import { render, staticRenderFns } from "./duoTileTitleMobile.vue?vue&type=template&id=e2508762&"
import script from "./duoTileTitleMobile.vue?vue&type=script&lang=js&"
export * from "./duoTileTitleMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports